import { DatePicker, Input, Select } from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import Authorization from "../../../../component/Authorization";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import { emptyIoPagination, IoPagination } from "../../../../helper/pagination";
import { entityService } from "../../shared/service/entity.service";
import { EntityOption } from "../../shared/shared.model";
import { RouteContext } from "../../user/screen/components/route.context";
import {
  PromotionBase,
  PromotionInquiry,
  PromotionUI,
} from "../entity/promotion.model";
import { promotionService } from "../service/promotion.service";
import PromotionTable from "./components/PromotionTable";

function Promotions() {
  const { RangePicker } = DatePicker;
  const { Option } = Select;
  const { dispatch } = useContext(SpinContext);
  const { state } = useContext(RouteContext);
  const [channels, setChannels] = useState<EntityOption[]>([]);
  const [promotionFilter, setPromotionFilter] = useState<PromotionInquiry>({
    page: 1,
    pageSize: 10,
  });
  const [promotionPagination, setPromotionPagination] = useState<
    IoPagination<PromotionUI>
  >({
    totalElements: 1,
    content: [],
  });

  let navigate = useNavigate();

  useEffect(() => {
    pageChange(promotionFilter);

    entityService.getChannels().then((_channels) => {
      setChannels(_channels);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.routeId]);

  const pageChange = (inquiry: PromotionInquiry) => {
    dispatch({ type: spinActions.BLOCK });

    if (state.routeId.length > 0) {
      inquiry.routeId = state.routeId;
    } else {
      inquiry.routeId = undefined;
    }

    promotionService
      .getPromotions(inquiry)
      .then((pagination: IoPagination<PromotionBase>) => {
        promotionPagination.current = inquiry.page;
        setPromotionPagination(pagination);
        dispatch({ type: spinActions.UNBLOCK });
      })
      .catch(() => {
        dispatch({ type: spinActions.UNBLOCK });
      });

    return () => {
      setPromotionPagination(emptyIoPagination);
    };
  };

  return (
    <>
      <MPageHeader crumbs={["Промошнууд"]} />

      <div className="content">
        <div className="card">
          <div className="card-header header-elements-inline">
            <h6 className="card-title">Промошнууд</h6>

            <Authorization roles={["promotion-full"]}>
              <div className="header-elements">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => navigate("/promotions/add")}
                >
                  <i className="icon-plus2 pr-1"></i>
                  Промошн нэмэх
                </button>
              </div>
            </Authorization>
          </div>
          <div className="card-body">
            <div className="d-flex bd-highlight example-parent mb-2">
              <Input
                placeholder="Нэр"
                onChange={(e) => {
                  setPromotionFilter({
                    ...promotionFilter,
                    name: e.target.value,
                  });
                }}
                style={{ width: 150 }}
              />

              <RangePicker
                className="ml-2"
                placeholder={["Эхлэх огноо", "Дуусах огноо"]}
                onChange={(dates, _dates) => {
                  setPromotionFilter({
                    ...promotionFilter,
                    startDate: _dates[0],
                    endDate: _dates[1],
                  });
                }}
                style={{ width: 250 }}
              />

              <Select
                allowClear
                className="ml-2"
                placeholder="Суваг сонгох"
                style={{
                  width: 150,
                }}
                onChange={(value) => {
                  setPromotionFilter({
                    ...promotionFilter,
                    channel: value,
                  });
                }}
              >
                {channels.map((e) => (
                  <Option value={e.label}>{e.label}</Option>
                ))}
              </Select>

              <button
                type="button"
                className="btn btn-sm btn-primary ml-2"
                onClick={() => {
                  let _promotionFilter = {
                    ...promotionFilter,
                    page: 1,
                    pageSize: 10,
                  };

                  pageChange(_promotionFilter);
                }}
              >
                <i className="icon-search4 mr-2" />
                Хайх
              </button>
            </div>

            <PromotionTable
              pagination={promotionPagination}
              onChange={(page: number, pageSize: number) => {
                let _promotionFilter = {
                  ...promotionFilter,
                  page,
                  pageSize: 10,
                };

                pageChange(_promotionFilter);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Promotions;
